import { render, staticRenderFns } from "./submitOrders.vue?vue&type=template&id=cae068e8&"
import script from "./submitOrders.vue?vue&type=script&lang=js&"
export * from "./submitOrders.vue?vue&type=script&lang=js&"
import style0 from "./submitOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports